<vl-layout>
  <router-outlet></router-outlet>
</vl-layout>
<vl-loading></vl-loading>
<vl-notification></vl-notification>
